import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

import { Button } from '../../components/Button/Button'
import { Section } from '../../components/Section'
import { useRoutes } from '../../routes'

export function SectionBrowserExtensionHero() {
  const routes = useRoutes()

  return (
    <Section
      isFirstSection
      containerTopPadding={120}
      containerBottomPadding={80}
      background="moon-dust-lighter"
      className="position-relative flexbox flexbox-align-center"
    >
      <div
        className={classNames(
          'flexbox flexbox-column flexbox-align-center text-align-center',
          'margin-left-auto margin-right-auto'
        )}
        style={{ maxWidth: 800 }}
      >
        <h1 className="font-family-title font-size-1 line-height-normal font-weight-medium shade-05">
          <FormattedMessage
            id="browserExtension.hero.title"
            defaultMessage="Your team assistant, right where you work"
          />
        </h1>
        <p
          className="font-size-4 line-height-large margin-top-16 shade-10"
          style={{ maxWidth: 600 }}
        >
          <FormattedMessage
            id="browserExtension.hero.subtitle"
            defaultMessage="Get context-aware answers and trigger workflows in one click from any website. No copy-pasting, no tab switching."
          />
        </p>

        <div className="margin-top-32 flexbox flexbox-align-center flexbox-gap-12">
          <Button
            variant="primary"
            size="default"
            href={routes.external.agentChromeExtension.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage
              id="browserExtension.hero.cta.add"
              defaultMessage="Add to Chrome"
            />
          </Button>
          <Button
            variant="secondary"
            size="default"
            href={routes.auth.signup()}
          >
            <FormattedMessage
              id="browserExtension.hero.cta.signup"
              defaultMessage="Get started free"
            />
          </Button>
        </div>
      </div>
    </Section>
  )
}
